
import React from 'react';
import queryString from 'query-string';

const trackedPush = (push, payload) => {
  window.dataLayer.push({
    event: 'TRACK_EVENT',
    ev: {
      category: 'Top Nav Bar Click',
      action: payload.pathname || payload,
    },
  });
  push(payload);
};

const trackedNewApp = (path, params) => () => {
  window.dataLayer.push({
    event: 'TRACK_EVENT',
    ev: {
      category: 'Top Nav Bar Click',
      action: path,
    },
  });
  window.location = (`${
    process.env.NEW_SYSTEM_URL
  }${path}?jwt=${localStorage.getItem('jwt')}${
    params ? `&${queryString.stringify(params)}` : ''
  }`);
};

import PartnerListIcon from 'material-ui/svg-icons/social/group';
import ContactListIcon from 'material-ui/svg-icons/social/person';
// import ConnectionListIcon from 'material-ui/svg-icons/content/link';
import MessagingCenterIcon from 'material-ui/svg-icons/communication/contact-mail';
import BounceListIcon from 'material-ui/svg-icons/action/info';
import BallotIcon from 'material-ui/svg-icons/action/dns';
import FormatListBulletedIcon from 'material-ui/svg-icons/editor/format-list-bulleted';

export const partnersMenu = ({ push }) => [{
  text: 'Partner List',
  icon: <PartnerListIcon color="rgba(0, 0, 0, 0.54)" />,
  onTouchTap: trackedNewApp('/partner-management/partner-list/partner'),
}, {
  text: 'Contact List',
  icon: <ContactListIcon color="rgba(0, 0, 0, 0.54)" />,
  onTouchTap: trackedNewApp('/partner-management/partner-list/contact'),
}, {
  type: 'divider',
}, {
  text: 'Messaging Center',
  icon: <MessagingCenterIcon color="rgba(0, 0, 0, 0.54)" />,
  onTouchTap: () => {
    trackedPush(push, '/workspace');
  },
}, {
  text: 'Bounce List',
  icon: <BounceListIcon color="rgba(0, 0, 0, 0.54)" />,
  onTouchTap: trackedNewApp('/partner-management/bounce-list'),
}, {
  text: 'Manage Data Properties',
  icon: <BallotIcon color="rgba(0, 0, 0, 0.54)"/>,
  onTouchTap: trackedNewApp('/partner-management/settings/data-properties'),
}, {
  text: 'Message Templates & Signature',
  icon: <FormatListBulletedIcon color="rgba(0, 0, 0, 0.54)"/>,
  onTouchTap: trackedNewApp('/partner-management/settings/message-templates-signature'),
}];

import ProfileIcon from 'material-ui/svg-icons/communication/business';
import SearchIcon from 'material-ui/svg-icons/action/search';
import NewsFeedIcon from 'material-ui/svg-icons/maps/satellite';
export const salesMarketingMenu = ({ push }) => [{
  text: 'Marketing Profile',
  icon: <ProfileIcon color="rgba(0, 0, 0, 0.54)" />,
  onTouchTap: () => {
    trackedPush(push, '/profile');
  },
}, {
  text: 'PartnerFinder',
  icon: <SearchIcon color="rgba(0, 0, 0, 0.54)" />,
  onTouchTap: () => {
    trackedPush(push, '/partner-finder/results');
  },
},
// {
//   text: 'Newsfeed',
//   icon: <NewsFeedIcon color="rgba(0, 0, 0, 0.54)" />,
//   onTouchTap: () => {
//     trackedPush(push, '/newsfeed');
//   },
// }
];

import DashboardIcon from 'material-ui/svg-icons/action/dashboard';
import ReportsIcon from 'material-ui/svg-icons/action/assessment';
import TemplateIcon from 'material-ui/svg-icons/action/description';
import ContractListIcon from 'material-ui/svg-icons/action/chrome-reader-mode';
import SendContract from 'material-ui/svg-icons/content/send';
export const supplierContractingMenu = ({
  templateListSearchParams,
  contractListType,
  contractListSearchParams,
  push,
  rateTemplatesCount,
}) => [{
  text: 'Dashboard',
  onTouchTap: () => {
    trackedPush(push, `/contracting/supplier-dashboard`);
  },
  icon: <DashboardIcon color="rgba(0, 0, 0, 0.54)"/>,
}, {
  text: 'Reports',
  onTouchTap: () => trackedPush(push, '/contracting/reports'),
  icon: <ReportsIcon color="rgba(0, 0, 0, 0.54)"/>,
}, {
  text: 'Rate Templates',
  onTouchTap: () => trackedPush(push, {
    pathname: `/contracting/template-list`,
    query: templateListSearchParams,
  }),
  icon: <TemplateIcon color="rgba(0, 0, 0, 0.54)"/>,
}, {
  text: 'Contract List',
  onTouchTap: () => trackedPush(push, {
    pathname: `/contracting/contract-list/${contractListType || 'recent'}`,
    query: contractListSearchParams,
  }),
  icon: <ContractListIcon color="rgba(0, 0, 0, 0.54)"/>,
}, {
  type: 'divider',
}, {
  type: 'subheader',
  text: 'Quick Links',
}, {
  text: 'Create a Template',
  onTouchTap: () => trackedPush(push, ('/contracting/create-template-draft')),
  icon: 'tc-icon-receipt',
},
  rateTemplatesCount
    ? {
      text: `Setup Next Year's Rates`,
      onTouchTap: () => trackedPush(push, '/contracting/create-template-draft'),
      icon: 'tc-icon-receipt',
    }
    : null, {
      text: 'Send Contracts',
      onTouchTap: trackedNewApp('/partner-management/send-assets', { go_back_to: window.location.href, open_asset_type: 'rates' }),
      icon: <SendContract color="rgba(0, 0, 0, 0.54)" />,
    },
  // {
  //   text: 'Send Contracts with Allocation',
  //   onTouchTap: trackedNewApp('/partner-management/send-assets', { go_back_to: window.location.href, open_asset_type: 'rates' }),
  //   icon: 'tc-icon-send-plus',
  // }
].filter(x => x);

export const buyerContractingMenu = ({
  push,
}) => [{
  text: 'Dashboard',
  onTouchTap: () => trackedPush(push, `/contracting/buyer-dashboard`),
  icon: <DashboardIcon color="rgba(0, 0, 0, 0.54)"/>,
}, {
  text: 'Reports',
  onTouchTap: () => trackedPush(push, '/contracting/reports'),
  icon: <ReportsIcon color="rgba(0, 0, 0, 0.54)"/>,
}, {
  text: 'Rates & Contracts',
  onTouchTap: () => {
      trackedNewApp('/contracting/workspace-list')();
  },
  icon: <ContractListIcon color="rgba(0, 0, 0, 0.54)"/>,
}];



// WEBPACK FOOTER //
// ./src/app/components/app-bar/subMenuItems.jsx